import * as React from 'react';

import { ImageCDNProvider, ModuleCarouselItem } from '@packages/common';
import { BaseImage } from '../BaseImage/BaseImage';

export type CarouselItemProps = ModuleCarouselItem & {
  onClick?: (item: CarouselItemProps) => void;
  cdnProvider?: ImageCDNProvider;
};

export const CarouselItem: React.FC<CarouselItemProps> = (props) => <BaseImage {...props} />;
